import axios from 'axios'
import wrappers from '../utils/wrappers'
import type { ActivityFeedPage, ActivityReactionResult, ActivityReactionType } from '../types/activity'

const url = `${import.meta.env.VITE_API_URL}/v1/notifications`

export type NotificationsInboxSession =
  | { configured: false }
  | {
      configured: true
      applicationIdentifier: string
      subscriberId: string
      subscriberHash: string
    }

export default {
  getInboxSession() {
    return axios
      .get(`${url}/inbox-session`)
      .then((response: any) => wrappers.handleEscribonautaResponse(response))
  },

  /**
   * Stores a browser push device token on the Novu subscriber (server-side credentials.append).
   * Outside this repo: enable Push + keys/VAPID in the Novu dashboard.
   */
  registerWebPushDevice(payload: { deviceToken: string; providerId?: string }) {
    return axios
      .post(`${url}/web-push/device`, payload, { timeout: 8000 })
      .then(
        (response: any) =>
          wrappers.handleEscribonautaResponse(response) as { data: { registered: boolean } },
      )
      .catch((error: any) =>
        wrappers.handleEscribonautaError(error, 'No se pudo registrar el dispositivo para avisos push'),
      )
  },

  listActivity(params?: { limit?: number; before?: string }) {
    return axios
      .get(`${url}/activity`, { params, timeout: 5000 })
      .then(
        (response: any) =>
          wrappers.handleEscribonautaResponse(response) as { data: ActivityFeedPage },
      )
      .catch((error: any) =>
        wrappers.handleEscribonautaError(error, 'No se pudo cargar la actividad'),
      )
  },

  reactToActivity(eventId: string, type: ActivityReactionType) {
    return axios
      .put(`${url}/activity/${eventId}/reaction`, { type }, { timeout: 5000 })
      .then(
        (response: any) =>
          wrappers.handleEscribonautaResponse(response) as { data: ActivityReactionResult },
      )
      .catch((error: any) =>
        wrappers.handleEscribonautaError(error, 'No se pudo guardar la reacción'),
      )
  },
}
